function switchTab(pillName) {
  $(`#${pillName} .news-training-cols`).each(function () {
    const transitionDuration = $(this).css('transition-duration');
    const transitionDelay = $(this).css('transition-delay');
    const $this = $(this);
    $this.css({
      'transition-duration': '0s',
      'transition-delay': '0s',
    });

    $this.removeClass('aos-animate');

    $this.css({
      'transition-duration': transitionDuration,
      'transition-delay': transitionDelay,
    });

    setTimeout(function () {
      $this.addClass('aos-animate');
    }.bind(this), 350);
  });
}

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    $('.news-and-training .nav-link').on('click', function () {
      if ($(this).attr('href') == '#pills-home') {
        switchTab('pills-home');
      } else {
        switchTab('pills-profile');
      }
    });

    // reset slot machine
    // to do: look into ways of achieving this through CSS as this is very hacky and requires the first & last field to be the same
    const $slotMachine = $('.slot-machine').clone();
    const slotIterations = $('.slot-machine .slot-value').length * 1800;

    setInterval(function () {
      const $slotMachineClone = $slotMachine.clone();
      $('.slot-machine').remove();
      $('.slot-machine-container').append($slotMachineClone);
    }.bind(this), slotIterations);

    // set banner height (for mobile as 100vh is unreliable)
    $('.hero-banner-wrap').css('height', $(window).height());
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js